import React, { useMemo, useState } from 'react';
import { returnUrl } from '../../aws-exports';
import { IProps } from './types';

export const AvatarFromAws = ({ photoKey, className }: IProps): JSX.Element => {
  const [image, setImage] = useState<null | string>();

  const getUrl = async() => {
    let result = photoKey;
    if (!photoKey.startsWith('https://')) {
      result = await returnUrl(photoKey) as unknown as string;
    }
    setImage(result);
  };

  useMemo(() => {
    getUrl();
  }, [photoKey]);

  return (
    <>
      {image && <img src={image} className={className} />}
    </>
  );
};
